module.exports = __webpack_public_path__ + "static/media/balance.4b7033f0.svg";